import actions from './actions';
import { initialValues } from '@iso/schemasAndValidations/Departments';

const initState = {
  departments: [],
  isLoading: false,
  modalActive: false,
  errorMessage: false,
  department: initialValues,
  categoryGroups: [],
  groupModal: false
};

export default function reducer(state = initState, { type, payload }) {
  switch (type) {
    case actions.LOAD_FROM_API:
      return {
        ...state,
        errorMessage: false,
        modalActive: false
      };
    case actions.LOAD_FROM_API_SUCCESS:
      return {
        ...state,
        departments: payload.data,
        errorMessage: false
      };
    case actions.LOAD_FROM_API_ERROR:
      return {
        ...state,
        errorMessage: 'There is a loading problem'
      };
    case actions.TOGGLE_API_HANDLE_MODAL:
      return {
        ...state,
        modalActive: !state.modalActive,
        department: payload.data == null ? initState.department : payload.data
      };
    case actions.TABLE_HANDLER:
      return {
        ...state,
        isState: payload.data
      };
    case actions.TOGGLE_LOADING:
      return {
        ...state,
        isLoading: payload.value
      };
    case actions.TOGGLE:
      return { ...state, modalActive: !state.modalActive, department: payload || {} };

    case actions.TOGGLE_GROUP_MODAL:
      return { ...state, groupModal: !state.groupModal, departmentGroup: payload || {} };

    case actions.LOAD_GROUP_SUCCESS:
      return { ...state, categoryGroups: payload };
    default:
      return state;
  }
}
